module.exports = __webpack_public_path__ + "img/4-2.a2a78fc2.jpg";